import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { IconExternalLink } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi, postApi } from '../../api/call.api'
import { PAGES_PREVIEW } from '../../api/static.data.pnp'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import Layout from '../../layout/Layout'
import BlocksList from './Components/BlocksForDrag/BlocksList'
import CarouselBlock from './Components/BlocksTypes/CarouselBlock'
import GridBlock from './Components/BlocksTypes/GridBlock'
import ImageBlock from './Components/BlocksTypes/ImageBlock'
import LinkBlock from './Components/BlocksTypes/LinkBlock'
import YoutubeBlock from './Components/BlocksTypes/YoutubeBlock'
import ChooseBuildElementModal from './Components/ChooseBuildElementModal'
import CreatePage from './Components/CreatePage'
import PagePreview from './Components/PageTemplates/PagePreview'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const CreatePageTabs = () => {

    const { pageId } = useParams();

    const [designTab, setDesignTab] = useState(1);
    const [blocksData, setBlocksData] = useState([]);
    const [pageData, setPageData] = useState({
        backgroundOption: { gradientAngle: 'to bottom' },
        headerOption: { gradientAngle: 'to bottom' },
        textOption: {},
        layout: 1,
        socialLinks: [],
        socialLinksOption: { color: 'original', placement: 'top' },
        blocksOption: {
            titleColor: '#000000',
            descriptionColor: '#000000',
        }
    });
    const [createBlockShow, setCreateBlockShow] = useState(null);
    const [pageName, setPageName] = useState(null);
    const mouseSensor = useSensor(MouseSensor)
    const touchSensor = useSensor(TouchSensor)
    const keyboardSensor = useSensor(KeyboardSensor)

    const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor)

    const onCancelBlockCreate = () => {
        setCreateBlockShow(null);
    }

    const handleAddBlock = async (data) => {
        let resp = await postApi(data, urlApi.addBlock + pageId);
        if (resp.responseCode === 200) {
            getPageDetail();
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    async function handleDragEnd(event) {
        const { active, over } = event;
        if (over && active?.id !== over?.id) {
            let local = [...blocksData];
            const activeIndex = local.findIndex(item => item._id === active.id);
            const overIndex = local.findIndex(item => item._id === over.id);
            let newArr = arrayMove(local, activeIndex, overIndex);
            setBlocksData(newArr);
            let resp = await postApi(newArr, urlApi.updateBlockPosition + pageId);
            if (resp.responseCode === 500) {
                toast.error(resp.message);
            }
        }
    }

    async function getPageDetail() {
        let resp = await getApi(urlApi.getPageDetailsByPageId + pageId);
        if (resp.responseCode === 200) {
            setPageName(resp?.data?.linkCode)
            setPageData(resp.data?.pageJson?.pageData);
            setBlocksData(resp.data?.pageJson?.blocksData);
        } else {
            toast.error(resp.message);
        }
    }

    async function publishPage() {
        let resp = await getApi(urlApi.publishPage + pageId);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getPageDetail();
    }, [pageId]);

    return (
        <Layout>
            <div className="text-center flex flex-wrap justify-center !gap-3 md:justify-between fixed bg-white w-[calc(100%-48px)] md:w-[calc(100%-300px)] top-[48px] pb-2 rounded-b-lg shadow-md px-3 z-30">
                {designTab == 1 ? <ChooseBuildElementModal selectItemFunction={(item) => setCreateBlockShow(item)} /> : <div className='w-9'></div>}
                <div className="flex items-center justify-center gap-4 border-2 w-max mx-auto px-2 py-1.5 rounded-lg">
                    <button onClick={() => setDesignTab(1)} className={`text-sm font-bold !px-5 py-1 rounded-md ${designTab == 1 && 'bg-primary text-white'}`}>Build</button>
                    <button onClick={() => setDesignTab(2)} className={`text-sm font-bold !px-5 py-1 rounded-md ${designTab == 2 && 'bg-primary text-white'}`}>Design</button>
                </div>
                <div className="flex items-center gap-3">
                    <Link to={PAGES_PREVIEW + pageName} target='_blank'> <IconButton icon={<IconExternalLink size={20} />} /></Link>
                    {accessCheck(accessKeys?.publishPage) && <button className='primary-btn' onClick={() => publishPage()}>Publish Now</button>}
                </div>
            </div>
            <div className='mt-3 grid grid-cols-3 pt-[80px] md:pt-[40px]'>
                {
                    designTab === 1 ?
                        <div className='col-span-3 md:col-span-2'>
                            {createBlockShow == "link" && <LinkBlock cancelFunction={() => onCancelBlockCreate()} createBlockFunction={(data) => handleAddBlock(data)} />}
                            {createBlockShow == "image" && <ImageBlock cancelFunction={() => onCancelBlockCreate()} createBlockFunction={(data) => handleAddBlock(data)} />}
                            {createBlockShow == "youtube" && <YoutubeBlock cancelFunction={() => onCancelBlockCreate()} createBlockFunction={(data) => handleAddBlock(data)} />}
                            {createBlockShow == "carousel" && <CarouselBlock cancelFunction={() => onCancelBlockCreate()} createBlockFunction={(data) => handleAddBlock(data)} />}
                            {createBlockShow == "grid" && <GridBlock cancelFunction={() => onCancelBlockCreate()} createBlockFunction={(data) => handleAddBlock(data)} />}
                            <div className='mt-2'>
                                {blocksData?.length > 0 ?
                                    <DndContext onDragEnd={handleDragEnd} modifiers={[restrictToVerticalAxis]} collisionDetection={closestCenter} sensors={sensors}>
                                        <SortableContext items={blocksData?.map(item => item?._id)} strategy={verticalListSortingStrategy}>
                                            {
                                                blocksData?.map((block, index) => {
                                                    return (
                                                        <BlocksList key={block?._id} blockData={block} callback={() => getPageDetail()} />
                                                    )
                                                })
                                            }
                                        </SortableContext>
                                    </DndContext>
                                    :
                                    (!createBlockShow && <div className='h-[40vh] flex items-center justify-center flex-col !p-10 text-center'>
                                        <p className='text-xl font-semibold'>Add links and fill those empty spaces</p>
                                        <p className='text-sm text-[var(--secondary-text)]'>Gather links from websites, social, videos, music... whatever <br /> you'd like! You'll create a cool, short page that can drive more <br />clicks, more views, and a wider audience.</p>
                                    </div>)
                                }
                            </div>
                        </div>
                        : <CreatePage state={pageData} pageId={pageId} callback={() => getPageDetail()} />
                }
                <div className="col-span-3 md:col-span-1 w-full">
                    <div className='max-w-[360px] mx-auto w-full static md:fixed ms-3'>
                        <PagePreview blocksData={blocksData?.filter(item => item?.status == 1)} pageData={pageData} />
                        <p className="text-xs mt-3">*Publish Your page for see the latest changes.</p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CreatePageTabs